<template>
  <div>
    <header>
      <h1>Zweispalter mit Floats</h1>
    </header>
    <nav class="mainnav">
      <h3>Navigation</h3>
      <ul>
        <li>
          <a href="#">Seite 1</a>
        </li>
        <li>
          <a href="#">Seite 2</a>
        </li>
        <li>
          <a href="#">Seite 3</a>
        </li>
        <li>
          <a href="#">Seite 4</a>
        </li>
        <li>
          <a href="#">Seite 5</a>
        </li>
      </ul>
    </nav>
    <section class="maincontent">
      <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
      <h2>Unterüberschrift H2</h2>
      <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
    </section>
    <footer>Zweispalter mit float</footer>
  </div>
</template>

<script>
export default {
  name: "Zweispalter-FloatView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
header {
  background-color: darkkhaki;
}
h1 {
  text-align: center;
  padding: 10px;
}
.mainnav {
  box-sizing: border-box;
  margin: 0;
  padding: 0 10px;
  border: 0;
  background-color: darkgrey;
}

.mainnav h3,
.mainnav ul {
  margin: 0.3em;
  list-style: none;
}

.mainnav ul {
  margin-bottom: 0.8em;
  padding-left: 0.3em;
}

.mainnav li {
  margin: 0.4em 0;
  padding: 0.2em;
  border: 1px solid gray;
  text-align: center;
}

.maincontent {
  box-sizing: border-box;
  margin: 0;
  padding: 0 20px;
  border: 0;
  background-color: cyan;
}

footer {
  clear: both;
  background-color: rgb(236, 206, 206);
}

@media only screen and (min-width: 660px) {
  .mainnav {
    float: right;
    width: 20%;
  }

  .maincontent {
    float: left;
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/css-examples/zweispalter-float.vue